import { DeleteScrapFinanceAccountsApi } from "@/features/accounts/scrap-finance/services/delete-accounts-api";
import { DeleteScrapFinanceAccountsRequestModel } from "@/features/accounts/scrap-finance/services/delete-accounts-model";

/// 銀行口座削除画面処理
export class DeleteScrapFinanceAccountsService {
  private deleteScrapFinanceAccountsApi = new DeleteScrapFinanceAccountsApi();

  /**
   * 銀行口座削除API実行
   */
  public async deleteScrapFinanceAccounts(param: DeleteScrapFinanceAccountsRequestModel) {
    return await this.deleteScrapFinanceAccountsApi.deleteScrapFinanceAccounts(param);
  }
}
